import React from 'react';
import PropTypes from 'prop-types';
import { Text, Icon } from '@reservamos/elements';
import cn from 'utils/cn';

/**
 * RedeemPointsMethod component.
 * @param {object} props - label, checked, data, onChange, iconType.
 * @param {string} props.label - The label text to display.
 * @param {boolean} props.checked - Whether the radio input is checked.
 * @param {string} props.data - Additional text data to display.
 * @param {function} props.onChange - Function to call when the radio input changes.
 * @param {string} props.iconType - Type of icon to display, either "Email" or "Phone".
 * @param {boolean} props.disabled - Whether the radio input is disabled.
 * @returns {React.ReactNode}
 */
const RedeemPointsMethod = ({ label, checked, data, onChange, iconType, disabled }) => {
  const handleOnChange = () => {
    if (disabled) return;
    onChange();
  };
  return (
    <div
      onClick={handleOnChange}
      className={cn(
        'flex items-center w-full rounded-2xl py-[10px] px-6 gap-4 cursor-pointer',
        'custom-shadow-light',
        disabled && 'opacity-50',
      )}
    >
      <div className="relative flex items-center justify-center">
        <div
          className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${
            checked ? 'border-primary-strong' : 'border-gray-200'
          }`}
        >
          {checked ? (
            <div className="w-2.5 h-2.5 rounded-full bg-primary-strong" />
          ) : (
            <div className="w-3.5 h-3.5 rounded-full bg-gray-100" />
          )}
        </div>
      </div>
      <div className="flex items-center">
        <Icon type={iconType} size="M" color="primaryStrong" />
      </div>

      <div className="flex flex-col items-start flex-grow">
        <Text color="primaryStrong" size="L" style={{ textAlign: 'left' }}>
          {label}
        </Text>
        <Text size="L" style={{ textAlign: 'left' }}>
          {data}
        </Text>
      </div>
    </div>
  );
};

RedeemPointsMethod.defaultProps = {
  iconType: 'Phone',
};

RedeemPointsMethod.propTypes = {
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  data: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  iconType: PropTypes.oneOf(['Email', 'Mobile']),
  disabled: PropTypes.bool,
};

export default RedeemPointsMethod;
